export default __webpack_public_path__ + "static/media/Icons_PROFILE.d94aae7e.svg";